<template>
	<div class="my-activity">
        <div class="empty" v-if="isEmpty">--- 暫無課程或活動 ---</div>
        <div class="my-activity-list">
            <div class="my-activity-item" v-for="item in dataList" :key="item.activityid">
                <div class="activity-name" v-text="item.title"></div>
                <div class="activity-address" v-text="`活動地址：${item.address || ''}`"></div>
                <div class="activity-time" v-text="'活動日期：' + item.starttime + '~' + item.endtime"></div>
                <div class="row">
                    <router-link :to="`/ActivityDetail/${item.activityid}`" class="btn-detail">活動詳情</router-link>
                    <a href="javascript:;" @click="()=>receiptDownload(item)" class="btn-download">收據下載</a>
                    <a href="javascript:;" v-if="item.showExam" @click="()=>getActivityQuestions(item, item.isSignIn)" class="btn-download tag1" v-text="item.isSignIn ? '答題通過' : '答題簽到' "></a>
                    <a v-if="item.isSignIn===true && Date.now()>=moment(item.starttime) && Date.now()<=moment(item.certDownloadEndDate)" href="javascript:;" @click="()=>certificateDownload(item)" class="btn-download tag2">出席證明</a>
                    <span v-if="item.isSignIn===true && Date.now()>=moment(item.starttime) && Date.now()<=moment(item.certDownloadEndDate)" class="download-notice">{{`( 請在${moment(item.starttime).format('YYYY-MM-DD HH:mm')} 至 ${moment(item.certDownloadEndDate).format('YYYY-MM-DD HH:mm')} 內下載出席證明 )`}}</span>
                </div>
            </div>
        </div>
        <a-modal
            title="答題前请观看完视频内容"
            :width="800"
            :height="450"
            :visible="videoVisible"
            cancelText="取消"
            okText="开始答题"
            @ok="videoVisible=false; showQuestionModal=true;"
            @cancel="videoVisible=false"
        >
            <youtube v-if="videoId" @playing="playing" @ended="ended" @pause="pause" :video-id="videoId"  player-width="100%" player-height="402" ></youtube>
            <iframe frameborder="0" style="width: 100%; height: 402px; overflow: hidden;" v-else :src="videoUrl" allowFullScreen="true"></iframe>
        </a-modal>
        <a-modal
            title="答題簽到"
            :width="800"
            :height="600"
            style="z-index: 10000;"
            :visible="showQuestionModal"
            :confirm-loading="onSubmitQuestionLoading"
            :maskClosable="false"
            cancelText="取消"
            okText="提交"
            @ok="submit"
            @cancel="onQuestionModalCancel"
        >
            <div class="question-container" v-if="showQuestionModal">
                <dl class="question-item"  v-for="(item, index) in questionList" :key="index">
                    <dt class="question-title" v-text="`${index+1}、${item.question}`"></dt>
                    <a-radio-group name="group" v-model="item['value']" v-if="item.questionType == 0">
                        <dd class="question-answer"><a-radio value="a">{{item['a']}}</a-radio></dd>
                        <dd class="question-answer"><a-radio value="b">{{item['b']}}</a-radio></dd>
                        <dd class="question-answer"><a-radio value="c">{{item['c']}}</a-radio></dd>
                        <dd class="question-answer"><a-radio value="d">{{item['d']}}</a-radio></dd>
                    </a-radio-group>
                    <input type="text" class="question-input-answer" placeholder="請輸入答案" v-model="item.answer" v-if="item.questionType == 1">
                </dl>
            </div>
        </a-modal>

        <a-modal
            title="提示"
            :visible="showAnserResultModal"
            :footer="null"
            @cancel="onAnswerModalCancel"
        >
            <a-result
                :status="isPass ? 'success' : 'error'"
                :title="isPass ? '您已經通過考核，已經幫您自動簽到！': '未通過考核'"
                :sub-title="answerResultSubTitle"
            >
                <template #extra>
                    <a-button key="console" type="primary" @click="onConifrmResult">確定</a-button>
                </template>
            </a-result>
        </a-modal>
        <loading v-if="loading"/>
	</div>
</template>

<script>
    import Loading from '../Loading.vue';
	import moment from 'moment'
	export default {
        components: {
            Loading,
        },
		mounted: function(){
            this.loadData()
		},
        beforeDestroy: function() {
            this.$notification.close('notification_my_activity')
        },
		data() {
            return {
                videoId: undefined,
                videoUrl: undefined,
                videoVisible: false,
                isEmpty: false,
                mActivityId: null,
                association: this.$store.getters.association,
                userInfo: this.$store.getters.userInfo,
                loading: true,
                dataList: [],
                pageNo: 1,
                pageSize: 10,
                total: 0,
                visible: false,
                isUpload: false,
                style: '',
                showQuestionModal: false,
                questionList: [
                    {
                        'question': '钠钾泵每消耗一分子的ATP（）',
                        'questionType': 0,
                        'a': 'A、向细胞内转运2分子K+，细胞外转运3分子Na+',
                        'b': 'B、向细胞内转运2分子Na+，细胞外转运3分子K+',
                        'c': 'C、向细胞内转运3分子K+，细胞外转运2分子Na+',
                        'd': 'D、向细胞内转运3分子Na+，细胞外转运2分子K+',
                    },
                    {
                        'question': '简述保证网络传输可靠性的确认和重传机制的概念',
                        'questionType': 1,
                    },
                    {
                        'question': '简述实现数据可靠传输的措施',
                        'questionType': 1,
                    },
                    {
                        'question': '根据近年来的研究，蛋白质糖基化常有两种连接方式，即N连接和O连接（）',
                        'questionType': 0,
                        'a': 'A、它们先后在rER和SER上形成',
                        'b': 'B、它们先后在rER和高尔基体上形成',
                        'c': 'C、它们先后在SER和高尔基体上形成',
                        'd': 'D、它们先后在rER和细胞质里形成',
                    },
                    {
                        'question': '哪个不属于细胞衰老的特征（）',
                        'questionType': 0,
                        'a': 'A、核仁缩小',
                        'b': 'B、胆固醇下降',
                        'c': 'C、线粒体的嵴减少',
                        'd': 'D、脂褐质积累',
                    }
                ],
                onSubmitQuestionLoading: false,
                transitionName: '',
                questionModalData: {},
                showAnserResultModal: false,
                isPass: true,
                rightAnswerCount: 0,
                allRight: false,

            }
        },
        created: function(){
            if(! this.userInfo) {
                this.$router.push('/')
                return
            }
        },
        computed: {
            answerResultSubTitle() {
                if(this.isPass) {
                    if(this.allRight) {
                        return '太棒了，所有的問題都回答正確！'
                    }
                    return `總共${this.questionList.length}您答對了${this.rightAnswerCount}條題目`
                }
                return `您錯了${this.questionList.length - this.rightAnswerCount}， 總共${this.questionList.length}條題目`
            },
           
        },
        methods: {
            playing(event) {
            },
            pause(event) {
            },
            ended(event) {
            },
            moment,
            onAnswerModalCancel(){
                this.showAnserResultModal = false
                window.location.reload()
            },
            onQuestionModalCancel() {
                if(this.onSubmitQuestionLoading) return
                this.showQuestionModal = false
                this.questionList.forEach(v=>delete v['value'])
            },
            submit() {
                //提交答題
                if(this.questionList.filter(v=>v.value).length == this.questionList.length) {
                    // this.onSubmitQuestionLoading = true
                    this.checkActivityAnswer(this.questionModalData, this.questionList.map(v=>({answer: v['value'], id: v.id })))
                } else {
                    this.$message.warning('有未答題的題目')
                }
            }, 
            async receiptDownload(_data) {
                try {
                    const response = await this.$store.dispatch('receiptDownload', {
                        activityId: _data.activityid,
                        userId: this.userInfo.clientid
                    })
                    if(response.type === 'application/json') {
                        const data = JSON.parse((await response.text()) || '{}')
                        data['msg'] && this.$message.warning(data['msg'])
                    } else {
                        let url = window.URL.createObjectURL(response);
                        let link = document.createElement("a");
                        link.setAttribute("download", `收據（${_data.title}）.pdf`);
                        link.style.display = "none";
                        link.href = url;
                        document.body.appendChild(link);
                        link.click();
                    }
                } catch (msg) {
                    this.$message.warning(msg || '操作失敗！')
                }
            },
            async getActivityQuestions(_data, isSignIn) {
                if(!_data) return
                if(isSignIn == true) {
                    this.$message.warning("您已經通過答題了")
                    return
                }
                this.$store.dispatch('getActivityQuestions', {
                    uid: this.userInfo.clientid,
                    activityId: _data.activityid,
                })
                .then((rs) => {
                    this.videoId = undefined
                    this.videoUrl = rs.examVideo || undefined
                    this.questionList = rs.activityExamList || []
                    this.questionModalData = _data
                    if(!this.videoUrl) {
                        this.showQuestionModal = true
                    } else {
                        var start = (this.videoUrl || '').indexOf('youtube.com/watch?v=')
                        if(start != -1) {
                            this.videoId = this.videoUrl.substr(this.videoUrl.indexOf('v=')+2)
                            if(this.videoId.length > 11) {
                                this.videoId = this.videoId.substring(0,11) 
                            }
                        } else {
                            start = (this.videoUrl || '').indexOf('youtu.be/')
                            if(start != -1) {
                                this.videoId = this.videoUrl.substr(this.videoUrl.indexOf('youtu.be/')+9)
                                if(this.videoId.length > 11) {
                                    this.videoId = this.videoId.substring(0,11) 
                                }
                            }
                        }
                        this.videoVisible = true
                    }
                })
            },
            async checkActivityAnswer(_data, activityExamAnswerList) {
                if(!_data) return
                this.onSubmitQuestionLoading = true
                this.$store.dispatch('checkActivityAnswer', {
                    "activityExamAnswerList": activityExamAnswerList,
                    "uid": this.userInfo.clientid,
                    "activityId": _data.activityid,
                })
                .then((data) => {
                    this.onSubmitQuestionLoading = false
                    this.showQuestionModal = false
                    this.questionList.forEach(v=>delete v['value'])
                    if(data) {
                        this.isPass = data.pass
                        this.allRight = data.allPass;
                        this.rightAnswerCount = ((data.answerResultList|| []).filter(v=>v['pass'])).length;
                        setTimeout(() => {
                            this.showAnserResultModal = true
                        }, 500)
                    }
                }).catch((rs) => {
                    this.$message.warning(rs)
                }).finally((rs)=>{
                    this.onSubmitQuestionLoading = false
                })
            },
            async certificateDownload(_data) {
                if(!_data) return
                var start = _data.starttime && new Date(_data.starttime.replace(/-/g, '/')).getTime()
                var now = Date.now()
                if(start && now < start) {
                    this.$message.warning('活動開始後才可下載出席證明！')
                    return
                }
                try {
                   const response =  await this.$store.dispatch('certificateDownload', {
                        activityId: _data.activityid,
                        userId: this.userInfo.clientid
                    })
                    if(response.type === 'application/json') {
                        const data = JSON.parse((await response.text()) || '{}')
                        data['msg'] && this.$message.warning(data['msg'])
                    } else {
                        let url = window.URL.createObjectURL(response);
                        let link = document.createElement("a");
                        link.setAttribute("download", `出席證明（${_data.title}）.pdf`);
                        link.style.display = "none";
                        link.href = url;
                        document.body.appendChild(link);
                        link.click();
                    }
                } catch (msg) {
                    this.$message.warning(msg || '操作失敗！')
                }
            },
            async loadData() {
                this.$store.dispatch('getMyActivitys', {
                    uid: this.userInfo.clientid,
                })
                .then((rs) => {
                    var list = rs.activityList || []
                    this.loading = false
                    this.dataList = list
                    this.isEmpty = list.length === 0
                    if(!this.isEmpty) {
                        // this.dataList[0].showExam = true
                        // this.dataList[0].isSignIn = false
                        // this.dataList[0].endtime = '2022-08-15'
                        if(this.dataList.filter((v)=>v.showExam == true && !v.isSignIn && Date.now() < moment(v.endtime)).length) {
                            this.$notification.info({
                                key: 'notification_my_activity',
                                message: '請報名者在活動開始後進入這頁面進行答題',
                                duration: null,
                            });
                        }
                    }
                }).catch((rs) => {
                    this.loading = false
                })
            },
            onConifrmResult() {
                window.location.reload()
            }
        }
	};
</script>

<style scoped>
    .my-activity {
        display: flex;
        flex-direction: column;
        position: relative;
        padding-bottom: 60px;
    }

    .my-activity > .empty {
        position: absolute;
        left: 50%;
        top: 80px;
        transform: translateX(-50%);
    }

    .my-activity-list {
        display: flex;
        flex-direction: column;
    }

    .my-activity-list .my-activity-item {
        display: flex;
        flex-direction: column;
        width: 756px;
        margin-left: 20px;
        margin-top: 28px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 8px 0px rgba(232,234,243,1);
        border-radius:16px;
        padding: 22px 18px 30px 20px;
        box-sizing: border-box;
        position: relative;
    }

    .my-activity-list .my-activity-item > .activity-name {
        color: #231F20;
        font-weight: bold;
        font-size: 20px;
        line-height: 1.2;
    }

    .my-activity-list .my-activity-item > .activity-address,
    .my-activity-list .my-activity-item > .activity-time {
        color: #969696;
        margin-top: 16px;
        font-weight: 400;
        font-size: 16px;
        line-height: 1.2;
    }

    .my-activity-list .my-activity-item > .activity-address {
        font-weight: 500;
    }

    .my-activity-list .my-activity-item > .row {
        display: flex;
        flex-direction: row;
        margin-top: 30px;
        width: 100%;
        align-items: center;
        flex-wrap: wrap;
    }

    .my-activity-list .my-activity-item > .row > .web-site {
        text-decoration: underline;
        color: rgba(255, 1, 99, 0.986);
        position: relative;
        font-size: 16px;
        font-weight: 400;
    }

    .my-activity-list .my-activity-item > .row > .web-site::before {
        content: '來源:';
        position: absolute;
        left: -49px;
        font-size: 16px;
        font-weight: 400;
        top: 50%;
        transform: translateY(-50%);
        color: #d8d7d7;
    }

    .my-activity-list .my-activity-item .activity-code {
        color: #231F20;
        font-size: 16px;
        font-weight: 400;
        line-height: 16px;
        margin-right: 255px;
    }
 
    .my-activity-list .my-activity-item .btn-download,
    .my-activity-list .my-activity-item .btn-detail {
        color: #1296db;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        position: relative;
        padding-left: 20px;
        margin-right: 37px;
        cursor: pointer;
    }

    .my-activity-list .my-activity-item .btn-download {
        color: #fa8306;
        
    }
    .my-activity-list .my-activity-item .btn-download.tag2 {
        margin-right: 0px;
    }

     .download-notice {
        color: #f00;
        position: absolute;
        left: 0;
        right: 0;
        text-align: center;
        bottom: 6px;
        white-space: nowrap;
    }
    .my-activity-list .my-activity-item .preview-img {
        width: 60px;
        height: 36px;
        position: absolute;
        right: 23px;
        bottom: 23px;
    }

    .my-activity-list .my-activity-item .preview-img > img {
        width: 100%;
        height: 100%;
    }

    .my-activity-list .my-activity-item .btn-download::after,
    .my-activity-list .my-activity-item .btn-detail::after {
        content: '';
        position: absolute;
        left: 0;
        top: 2px;
        width: 14px;
        height: 16px;
        background-image: url(../../assets/imgs/ic_book.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .my-activity-list .my-activity-item .btn-download::after {
        top: 2px;
        background-image: url(../../assets/imgs/ic_download.png);
    }

	.split-pages-container {
		position: absolute;
		bottom: 20px;
		right: 20px;
		display: flex;
		flex-direction: row;
		margin-top: 25px;
		justify-content: flex-end;
	}

	.split-pages-container > .split-pages {
		display: flex;
		flex-direction: row;
	}

	.split-pages-container > .split-pages > .split-page {
		display: inline-block;
		width: 22px;
		height: 22px;
		border-radius: 50%;
		color: #969696;
		font-size: 14px;
		line-height: 22px;
		text-align: center;
		font-weight: 400;
		margin-right: 20px;
		background-color: #DDDDDD;
		cursor: pointer;
	}

	.split-pages-container > .split-pages > .split-page.more {
		line-height: 16px;
	}

	.split-pages-container > .split-pages > .split-page:hover,
	.split-pages-container > .split-pages > .split-page.current {
		color: #fff;
		background-color: #36C4D0;
		font-weight: bold;
	}

	.split-pages-container > .btn-page-prev,
	.split-pages-container > .btn-page-next {
		height: 20px;
		width: 56px;
		text-align: center;
		line-height: 20px;
		font-weight: 300;
		color: #636363;
		background-color: #DDDDDD;
		border-radius: 4px;
		font-weight: 400;
		font-size: 14px;
		cursor: pointer;
	}

	.split-pages-container > .btn-page-next {
		margin-left: 24px;
		color: #231F20;
    }

    @media only screen and (max-width: 1050px) {
        .my-activity-list .my-activity-item {
            width: unset;
            height: unset;
            margin: 12px;
        }

        .my-activity-list .my-activity-item .activity-code {
            margin-right: 12px;
        }
    }
    
    @media only screen and (max-width: 790px) {
        .download-notice {
            position: absolute;
            left: 0;
            right: 0;
            text-align: center;
            bottom: 6px;
            white-space: nowrap;
        }
        .my-activity-list .my-activity-item .btn-download,
        .my-activity-list .my-activity-item .btn-detail {
            margin-right: 20px;
        }
    }

    .question-container {
        position: relative;
        height: 60vh;
        overflow-y: scroll;
        width: 100%;
    }

   .question-container .question-item {
        background-color: #fff;
        margin-bottom: 12px;
    }

    .question-container .question-title {
        font-size: 17px;
        font-weight: bold;
        color: #151515;
        line-height: 32px;
        margin-bottom: 10px;
    }

    .question-container .question-answer {
        font-size: 14px;
        font-weight: normal;
        color: #666;
        line-height: 32px;
    }

    .question-container .question-input-answer {
        font-size: 14px;
        font-weight: normal;
        color: #333;
        line-height: 32px;
        width: calc(100% - 16px);
        border-radius: 2px;
        padding: 0px 12px;
        box-sizing: border-box;
        margin: 0px 8px;
        border: 1px solid #f1f1f1;
    }

    .slideNext-enter-active, .slideNext-leave-active {
        transition: all .6s linear;
    }

    .slideNext-enter, .slideNext-leave-to {
        margin-left: 100%;
        opacity: 1;
    }

    .slideNext-leave-to {
        margin-left: -100%;
        opacity: .3;
    }

    .slidePrev-enter-active, .slidePrev-leave-active {
        transition: all .6s linear;
    }

    .slidePrev-enter, .slidePrev-leave-to {
        margin-left: -100%;
        opacity: .3;
    }

    .slidePrev-leave-to {
        margin-left: 100%;
        opacity: 1;
    }
    

</style>
